import React, { useEffect } from "react";
import useAuthState from "../auth/useAuthState.js";
import { AccommodationIcon } from "../accommodation/AccommodationIcon.tsx";
import { BOOK_DATE_FORMAT } from "./BookConstant.ts";
import format from "date-fns/format";
import useBookState from "./useBookState.ts";

interface BookNoPlanListProps {
    //token: string;
    //onCancel: () => void;
    openDetailPannel: (id: number, accommodation_id: number) => void;
}

export const BookNoPlanList: React.FC<BookNoPlanListProps> = ({ openDetailPannel }: BookNoPlanListProps) => {
    const { token, getToken } = useAuthState();
    const { book_list, getNoPlanList } = useBookState();

    useEffect(() => {
        if (token) getNoPlanList(token);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {book_list ? (
                <div className="toggle-pannel-header">
                    <div className="toggle-title">プラン未設定</div>
                </div>
            ) : null}
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                <thead>
                    <tr>
                        <th style={{ padding: "2px 8px", textAlign: "left", borderBottom: "1px solid #ddd", width: "80px" }}>施設</th>
                        <th style={{ padding: "2px 8px", textAlign: "left", borderBottom: "1px solid #ddd", width: "130px" }}>宿泊日</th>
                        <th style={{ padding: "2px 8px", textAlign: "left", borderBottom: "1px solid #ddd" }}>宿泊者</th>
                        <th style={{ padding: "2px 8px", textAlign: "left", borderBottom: "1px solid #ddd", width: "100px" }}>部屋</th>
                        <th style={{ padding: "2px 8px", textAlign: "left", borderBottom: "1px solid #ddd", width: "130px" }}>予約発生日</th>
                        <th style={{ padding: "2px 8px", textAlign: "center", borderBottom: "1px solid #ddd", width: "80px" }}>詳細</th>
                    </tr>
                </thead>
                <tbody>
                    {book_list
                        ? book_list.map((book) => {
                              return (
                                  <tr key={book.book_id}>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee" }}>
                                          {book.accommodation_id && token ? <AccommodationIcon token={token} id={book.accommodation_id} /> : null}
                                      </td>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee" }}>{format(book.start_date, BOOK_DATE_FORMAT)}</td>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee" }}>{book.name}</td>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee" }}></td>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee" }}>{format(book.created_at, BOOK_DATE_FORMAT)}</td>
                                      <td style={{ padding: "2px 8px", borderBottom: "1px solid #eee", textAlign: "center" }}>
                                          <button onClick={() => openDetailPannel(book.book_id, book.accommodation_id)} className="link">
                                              詳細
                                          </button>
                                      </td>
                                  </tr>
                              );
                          })
                        : null}
                </tbody>
            </table>
        </>
    );
};
